import React from 'react';
import { useSelector } from 'react-redux';

import { MdArrowForwardIos } from 'react-icons/md';

import { FaHeart, FaRegThumbsUp } from 'react-icons/fa';

import { isValidPrice, makeStatsRequestThrottled } from 'lib';
import { Channel } from 'components/channel';
import { WIDGET_STATS_SETTINGS } from 'config';

const BestRateSection = () => {
    const ourPrice = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice
    );

    const channels = useSelector((state) => state.miniBookingWidget?.channels);

    const data = useSelector(
        (state) => state.miniBookingWidget?.data?.bigPlugin
    );
    const propertyID = data?.propertyID;
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const showSection =
        ourPrice?.price || ourPrice?.loyaltyprice || channels.length > 0;

    const hasCart = useSelector(
        (state) => state.miniBookingWidget?.data?.hasCart
    );
    const linkProps = {
        rel: 'noopener noreferrer',
    };

    if (!hasCart) {
        linkProps.href = ourPrice ? ourPrice.bigPluginUrl : '';
        linkProps.target = '_blank';
    }
    return (
        showSection && (
            <div className="ab-body-sidebar-section pb-10">
                <div className="ab-section-header">
                    <div
                        role="button"
                        tabIndex="0"
                        className="ab-header-title"
                        aria-label={`${data?.bestAvailablePriceText}`}
                        aria-expanded="true"
                    >
                        <div>{data?.bestAvailablePriceText}</div>
                    </div>
                </div>
                <div className="ab-section-body">
                    {/* TODO: MAYBE CREATE A COMPONENT FOR THIS */}
                    {isValidPrice(ourPrice?.loyaltyprice) && (
                        <a
                            href={ourPrice.loyaltyBigPluginUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() =>
                                makeStatsRequestThrottled(
                                    WIDGET_STATS_SETTINGS.actions.booknow,
                                    propertyID
                                )
                            }
                        >
                            <div className="ft-price member-price-container">
                                <div className="ft-price-member-price-box">
                                    <div className="ft-price-header">
                                        {ourPrice?.loyaltytext}
                                        <span className="ab-NextToPriceIcons ab-GreenHeartClass">
                                            <FaHeart size={14} />
                                        </span>
                                    </div>
                                    <div className="ft-price-inner">
                                        <span className="ab-memberprice">
                                            {ourPrice.loyaltyprice}{' '}
                                            {ourPrice?.currencySymbol}
                                        </span>{' '}
                                        <div>
                                            <span className="svg ab-icon ab-memberprice-icon">
                                                <MdArrowForwardIos size={14} />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    )}

                    {isValidPrice(ourPrice?.price) && (
                        <a {...linkProps}>
                            <div
                                className="ft-price official-price-container"
                                onClick={() =>
                                    makeStatsRequestThrottled(
                                        WIDGET_STATS_SETTINGS.actions.booknow,
                                        propertyID
                                    )
                                }
                            >
                                <div className="ft-price-member-price-box">
                                    <div className="ft-price-header">
                                        {Lang?.directPrice}
                                        <span className="ab-NextToPriceIcons ab-ThumpsUpClass">
                                            <FaRegThumbsUp size={15} />
                                        </span>
                                    </div>
                                    <div className="ft-price-inner">
                                        <span className="ab-officialprice">
                                            {ourPrice?.price}{' '}
                                            {ourPrice?.currencySymbol}
                                        </span>{' '}
                                        <div>
                                            <span className="svg ab-icon ab-memberprice-icon">
                                                <MdArrowForwardIos size={14} />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    )}

                    {channels?.map((channel) => {
                        return (
                            <Channel
                                channelId={channel?.channelID}
                                currencySymbol={channel?.currencySymbol}
                                extraClasses={['ab-channel--big-widget']}
                                key={channel?.channelID}
                                logo={channel?.logo}
                                name={channel?.name}
                                price={'getFromState'}
                                // price={channel?.price}
                            />
                        );
                    })}
                </div>
            </div>
        )
    );
};

export default BestRateSection;
